declare const angular: ng.IAngularStatic;
declare const parseInt, RegExp;
export class storeCartController {
  checking: boolean;
  cart;
  user;
  removeVendor;
  productDetailUrl;
  constructor(
    private $cart,
    private $scope: ng.IScope,
    private $timeout,
    private $user,
    private $mdDialog,
    private $mPath,
    private $order,
    private MyConstant,
    private $window,
    private $http: ng.IHttpService
  ) {
    "ngInject";
  }

  $onInit() {
    this.addTooltipStyle();
    this.$mPath.get().then(response => {
      this.productDetailUrl = response.StoreProductDetail;
    });
    this.$user.getInfo().then(user => {
      this.user = user.data;
      this.cart = this.$cart.get(user.data);
      for (let venodrIndex in this.cart) {
        this.checkCartStatus(this.cart[venodrIndex], venodrIndex);
      }
    });
}
checkCartStatus(vendor, vendorIndex) {
    vendor.checking = true;
    
    // this.cart.map((vendor, vendorIndex) => {
    // this.cart[vendorIndex].checking = true;
    // this.$scope.$applyAsync(this.cart);
    // if (
    //   this.$scope.$root.$$phase != "$apply" &&
    //   this.$scope.$root.$$phase != "$digest"
    // ) {
    //   this.$scope.$apply();
    // }
    let itemToSend = [];
    this.cart[vendorIndex].$error = false;
    this.cart[vendorIndex].$notify = false;
    vendor.salabelItems.map(item => {
      itemToSend.push({
        BasePrice: item.BasePrice,
        FinalPrice: item.FinalPrice,
        Quantity: item.count,
        SalableItemID: item.SalableItemID,
        VendorID: vendor.VendorID
      });
    });
    this.$order.checkStatus(itemToSend).then(response => {
      response.data.map((item, key) => {
        this.cart[vendorIndex].salabelItems[key].$error = [];
        this.cart[vendorIndex].salabelItems[key].$notify = false;
        if (item.IsConditionChanged) {
          this.cart[vendorIndex].$error = [];
          item.ChangeTypes.map(changeType => {
            if (changeType == "MinimumOrderCount") {
              this.cart[vendorIndex].$error.push(
                `این محصول عمده فروشی می باشد برای اطلاعات بیشتر روی ایکون (i) در لیست بالا بروید`
              );

              this.cart[vendorIndex].salabelItems[key].$error.push(
                `کمترین تعدادی که می توانید این محصول را به سبد خرید خود اضافه کنید ${
                  item.MinimumOrderCount
                } عدد می باشد`
              );
            }
            if (changeType == "Price") {
              this.cart[vendorIndex].$notify =
                "قیمت محصولاتی که در فهرست سبد خرید شما در کادر زرد قرار گرفته‌اند تغییر کرده است. برای مشاهده شرح خطا، روی آیکون ( i ) کلیک فرمایید.";

              this.cart[vendorIndex].salabelItems[
                key
              ].$notify = `توجه داشته باشید که قیمت این محصول از زمانی که آن را به سبد خرید خود افزوده‌اید تا کنون تغییر کرده است`;
              this.cart[vendorIndex].salabelItems[key].BasePrice =
                item.BasePrice;
              this.cart[vendorIndex].salabelItems[key].FinalPrice =
                item.FinalPrice;
              this.$cart.changeSalabelItem(this.user, this.cart[vendorIndex]);
            }
            if (changeType == "Quantity") {
              this.cart[vendorIndex].$error.push(
                "موجودی انبار محصولاتی که در فهرست سبد خرید شما در کادر قرمز قرار گرفته‌اند تغییر کرده است. برای مشاهده شرح خطا، روی آیکون ( i ) کلیک فرمایید."
              );

              this.cart[vendorIndex].salabelItems[key].$error.push(
                `موجودی انبار برای خرید این محصول کمتر از تعداد درخواستی شما است. لطفا تعداد آن را کاهش دهید.`
              );
            }
          });
        } //end if
        else {
          this.$cart.changeSalabelItem(this.user, this.cart[vendorIndex]);
        }
      });
      vendor.checking = false;
    });
    // vendor.checking = false;
    // this.$scope.$apply();
    // });
  }
  saveChangeCount(vendor, vendorIndex) {
    this.$cart.changeSalabelItem(this.user, vendor);
    this.checkCartStatus(vendor, vendorIndex);
  }
  changeCount(vendor, vendorIndex, salabelIndex) {
    let isNumber = parseInt(vendor.salabelItems[salabelIndex].count);
    if (!isNumber || isNumber < 1) {
      vendor.salabelItems[salabelIndex].count = 1;
    }
    vendor.salabelItems[salabelIndex].count = parseInt(
      vendor.salabelItems[salabelIndex].count
    );
    this.saveChangeCount(vendor, vendorIndex);
  }

  increaseCount(vendor, vendorIndex, salabelIndex) {
    vendor.salabelItems[salabelIndex].count += 1;
    this.saveChangeCount(vendor, vendorIndex);
  }

  decreaseCount(vendor, vendorIndex, salabelIndex) {
    if (vendor.salabelItems[salabelIndex].count > 1) {
      vendor.salabelItems[salabelIndex].count -= 1;
      this.saveChangeCount(vendor, vendorIndex);
    }
  }

  removeItem(vendor, venodrIndex, salabelIndex) {
    let conformDialog = this.$mdDialog
      .confirm()
      .textContent("در صورت تایید این محصول از سبد خرید حذف میشود");

    this.$mdDialog.show(conformDialog).then(
      response => {
        vendor.salabelItems.splice(salabelIndex, 1);
        if (vendor.salabelItems.length == 0) {
          this.removeVendor = true;
          angular.forEach(this.cart, (val, key) => {
            if (val.VendorID == vendor.VendorID) {
              this.$cart.removeVendor(this.user, vendor);
              this.cart.splice(key, 1);
            }
          });
        } else {
          this.$cart.changeSalabelItem(this.user, vendor);
        }
        this.saveChangeCount(vendor, venodrIndex);
      },
      reject => {}
    );
  }

  goCheckout(vendor) {
    this.$user.getInfo().then(user => {
      if (user.data) {
        vendor.checking = true;
        this.$cart.setCheckOut(user.data, vendor).then(orderId => {
          this.$mPath.get().then(response => {
            this.$window.location.href = `${
              response.StoreCheckout
            }/order/${orderId}/address/`;
          });
        });
      } else {
        this.$user.showLogin();
      }
    });
  }

  private addTooltipStyle() {
    var css = `.md-tooltip {
            font-size: 15px;
            height: 38px;
            line-height: 22px;
            padding-right: 8px;
            padding-left: 8px;
            padding-top: 8px;
            padding-bottom: 8px;
        }`;
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");

    style.type = "text/css";
    style.appendChild(document.createTextNode(css));

    head.appendChild(style);
  }
}



// WEBPACK FOOTER //
// ./src/components/store-cart/store-cart.controller.ts